import { takeLatest, all, put, select } from 'typed-redux-saga';
import { getApiParams } from 'api';
import { moscowPopularCategoriesID, regionPopularCategoriesData, TTopCategory } from 'data';
import { getPopularCategoriesData, sortList } from 'utils';
import { selectPageModelCategoryId, selectPageModelRegionId } from 'store/pageModel';
import { setPopularCategoriesData } from '../popular-categories';
import {
	fetchTopCategoriesFailed,
	fetchTopCategoriesRequest,
	fetchTopCategoriesSuccess,
} from './slice';
import { fetchTopCategories } from './api';

export function* catalogueRootSaga() {
	return yield all([takeLatest(fetchTopCategoriesRequest.type, () => getTopCategories())]);
}

export function* getTopCategories() {
	try {
		const regionCode: string = yield select(selectPageModelRegionId);
		const categoryId: string = yield select(selectPageModelCategoryId);

		const { url, config } = yield getApiParams(
			'/services-platform/v0/slp/categories-for-landings'
		);
		const data: TTopCategory[] = yield fetchTopCategories(url, { regionCode }, config);

		if (regionCode === '34') {
			const popularCategories = getPopularCategoriesData(data, moscowPopularCategoriesID);
			yield put(setPopularCategoriesData({ categoriesData: popularCategories }));
		} else {
			yield put(setPopularCategoriesData({ categoriesData: regionPopularCategoriesData }));
		}

		const filteredData = categoryId
			? data.filter(({ topCategoryId }) => topCategoryId === Number(categoryId))
			: data;

		const withoutEmptyTopCategories = filteredData.filter(
			({ categories }) => categories.length
		);

		yield put(
			fetchTopCategoriesSuccess({
				data: sortList(withoutEmptyTopCategories) as TTopCategory[],
			})
		);
	} catch (error) {
		yield put(
			fetchTopCategoriesFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}
